var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackpack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.896 3.55l.207-1.283c.058-.374.427-.63.809-.573l1.869.28-.252 1.57M15.787 1.98l.363 1.57M11.104 3.55l-.207-1.283c-.058-.374-.427-.63-.809-.573l-1.869.28.252 1.57M8.213 1.98L7.85 3.55M17.793 9.143a6.349 6.349 0 011.002 3.42v6.564c0 1.208-1.015 2.186-2.27 2.186H7.482c-1.255 0-2.27-.978-2.27-2.186v-6.565c0-1.245.361-2.41.989-3.4M16.667 16.46H7.333M14.293 16.46v.935M2.39 9.155h3.791M6.744 4.172H2.391",
    stroke: "#222",
    className: "stroke",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.767 9.155h3.842C22.38 9.155 23 8.04 23 6.664c0-1.377-.621-2.492-1.39-2.492h-4.354M14.455 9.155h3.312M6.181 9.155h3.306M2.39 9.162c.769 0 1.392-1.115 1.392-2.491 0-1.376-.623-2.491-1.391-2.491S1 5.295 1 6.67c0 1.377.623 2.492 1.39 2.492zM12.003 12.725c-.42 0-.763-.33-.763-.735V9.267h1.527v2.723a.755.755 0 01-.764.735z",
    stroke: "#222",
    className: "stroke",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.256 4.178c.246.293.394.667.394 1.071 0 2.218-1.87 4.018-4.172 4.018h-2.956c-2.303 0-4.172-1.8-4.172-4.018 0-.404.148-.778.394-1.07",
    stroke: "#222",
    className: "stroke",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.744 4.178a1.776 1.776 0 011.372-.629h7.768c.557 0 1.048.243 1.372.63",
    stroke: "#222",
    className: "stroke",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackpack);
export default __webpack_public_path__ + "static/media/backpack.0f9516ba.svg";
export { ForwardRef as ReactComponent };